import template from './enum_objective.html'
import './enum_objective.css'

export default {
  template,
  controller: 'enumObjectiveController as enumObjective',
  bindings: { data: '=' }
}
